import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/data/translations";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");
  const [currency, setCurrency] = useState(() => localStorage.getItem("currency") || "AED");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("lang", lang);
  }, [lang]);

  useEffect(() => {
    localStorage.setItem("currency", currency);
  }, [currency]);

  // AED is base. Approx static rates as of late 2025.
  const rates = { AED: 1, USD: 0.272, GBP: 0.215, INR: 23.1 };
  const symbols = { AED: "AED", USD: "$", GBP: "£", INR: "₹" };

  const formatPrice = (aedValue) => {
    const v = aedValue * rates[currency];
    if (v >= 1_000_000) return `${symbols[currency]} ${(v / 1_000_000).toFixed(2)}M`;
    if (v >= 1_000) return `${symbols[currency]} ${(v / 1_000).toFixed(0)}K`;
    return `${symbols[currency]} ${Math.round(v).toLocaleString()}`;
  };

  const t = (key) => {
    const dict = translations[lang] || translations.en;
    return dict[key] ?? translations.en[key] ?? key;
  };

  return (
    <AppContext.Provider
      value={{ lang, setLang, currency, setCurrency, formatPrice, t, isRTL: lang === "ar" }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
};
